import api from "../../../api/client";

const MODULE_LABELS = {
  po: "Purchase Order",
  inventory: "Inventory",
  taskManagement: "Task Management",
  assets: "Asset Management",
};

// Re-checks enabledModules against the server (AuthContext's copy can be stale
// if a superadmin toggled the module after this session loaded) and syncs it back.
export async function verifyModuleEnabled(moduleKey, { enabledModules, setEnabledModules }) {
  let fresh = enabledModules;
  try {
    const res = await api.get("/manufacturing/module-status");
    if (Array.isArray(res.data?.enabledModules)) {
      fresh = res.data.enabledModules;
      setEnabledModules(fresh);
    }
  } catch {
    // fall back to the cached value if the refresh fails
  }
  const allowed = !fresh || fresh.includes(moduleKey);
  return {
    allowed,
    message: `${MODULE_LABELS[moduleKey] || moduleKey} module is not enabled for your company`,
  };
}
